import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountV2Service, AlertActionInfo } from 'src/app/services/account-v2-service';

/**
 * Tokenised email action page (§6): pause / unsubscribe links from alert
 * emails land here and MUST work without login. The token is the
 * authorisation; it is single-use and expiring, so the page always asks for
 * one explicit confirmation click before consuming it.
 */
@Component({
  selector: 'pla-alert-action',
  templateUrl: './alert-action.component.html',
  styleUrls: ['./alert-action.component.scss'],
})
export class AlertActionComponent implements OnInit {
  public state: 'loading' | 'confirm' | 'working' | 'done' | 'invalid' = 'loading';
  public info: AlertActionInfo | null = null;
  public invalidReason: string | null = null;
  private token = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountService: AccountV2Service
  ) { }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') || '';
    if (this.token === '') {
      this.state = 'invalid';
      this.invalidReason = 'unknown';
      return;
    }
    this.accountService.describeAlertAction(this.token).subscribe({
      next: (info) => {
        this.info = info;
        this.state = 'confirm';
      },
      error: (err) => {
        this.state = 'invalid';
        this.invalidReason = (err && err.error && err.error.invalidReason) || 'unknown';
      },
    });
  }

  public confirm(): void {
    this.state = 'working';
    this.accountService.consumeAlertAction(this.token).subscribe({
      next: (info) => {
        this.info = info;
        this.state = 'done';
      },
      error: (err) => {
        this.state = 'invalid';
        this.invalidReason = (err && err.error && err.error.invalidReason) || 'unknown';
      },
    });
  }

  public get invalidMessage(): string {
    switch (this.invalidReason) {
      case 'expired':
        return 'This link has expired. You can still manage every alert from your account.';
      case 'used':
        return 'This link has already been used. Nothing further has changed.';
      default:
        return "This link isn't recognised. It may have been trimmed by your email client; you can manage every alert from your account.";
    }
  }
}
